import { GenericRemoteActionBuilder } from '../remote-action-builder';
import { Injectable, ViewContainerRef, ComponentRef } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { ClientStateService } from 'src/app/_services/client-state/logic/client-state.service';
import { RemoteAction } from '../../remote-action';
import { TimeCorrectionRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/time-correction-remote-action-builder-ui-step/time-correction-remote-action-builder-ui-step';

import { LocationService } from 'src/app/_services/location/location.service';
import { PlaceTypeRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/placetype-remote-action-builder-service-step/placetype-remote-action-builder-service-step';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { GpsRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/gps-remote-action-builder-service-step/gps-remote-action-builder-service-step';
import { RemoteActionService } from 'src/app/_services/remote-action/logic/remote-action.service';
import { Tour, TourStatus } from 'src/app/_model/tour';
import { TourService } from 'src/app/_services/tour/logic/tour.service';
import { TimeCorrectionComponent } from 'src/app/_components/remote-action-step/time-correction/time-correction.component';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { TourTravelRemoteActionBuilder } from '../tour-travel-remote-action-builder/tour-travel-remoteaction-builder';
import { TourTravelRemoteActionType } from '../tour-travel-remote-action-builder/tour-travel-remote-action-type';
import { GPSTrackService } from 'src/app/_services/gps-track/gps-track.service';

@Injectable()
export class TourEndRemoteActionBuilder extends GenericRemoteActionBuilder {
  constructor(
    tour: Tour,
    dependentDynFormRemoteActions: RemoteAction[],
    appService: AppService,
    credentialsService: CredentialsService,
    locationService: LocationService,
    private clientStateService: ClientStateService,
    private tourService: TourService,
    private remoteActionService: RemoteActionService,
    private appParameterService: AppParameterService,
    gpsTrackService: GPSTrackService,
    private logger?: LoggingService
  ) {
    super(
      'TOUR-END-REMOTEACTION.PAGE-TITLE',
      appService,
      credentialsService,
      {
        endpoint: 'tourend',
        data: {
          currenttourid: tour.id.imsId,
        },
        cachable: true,
        fifo: true,
        authenticationRequired: true,
        shortLabel: 'TOUR-END-REMOTEACTION.RA.LABEL.SHORT',
        shortLabelTranslate: true,
        longLabel: tour.label,
        longLabelTranslate: false,
      },
      [].concat([new TimeCorrectionRemoteActionBuilderUiStep(logger)]),
      [
        new PlaceTypeRemoteActionBuilderServiceStep(clientStateService, logger),
        new GpsRemoteActionBuilderServiceStep(locationService, logger),
      ],
      async () => {
        logger.log(this.constructor.name, ' Executing post generate function');

        for (const dependentFormRA of dependentDynFormRemoteActions) {
          this.logger.log(
            this.constructor.name,
            'transmit dependent remoteaction',
            dependentFormRA.shortLabel,
            dependentFormRA.longLabel
          );
          this.remoteActionService.sendRemoteAction(dependentFormRA);
        }

        if (
          !tour.hasActiveManagedDevice &&
          appParameterService.appParameters$
            .getValue()
            .getBooleanParameter('imsmc.tour.btrip-generation', false)
        ) {
          let stopLeaveRab = new TourTravelRemoteActionBuilder(
            TourTravelRemoteActionType.END_OF_TOUR,
            tour,
            undefined,
            undefined,
            this.clientStateService,
            appService,
            credentialsService,
            locationService,
            this.tourService,
            gpsTrackService,
            this.appParameterService,
            this.logger
          );
          let stopLeaveRa = await stopLeaveRab.generateRemoteAction([]);
          await this.remoteActionService.sendRemoteAction(stopLeaveRa);
        }

        tour.status = TourStatus.STATUS_FINISHED;
        await this.tourService.updateTour(tour);

        this.clientStateService.setTourId(undefined);
        this.clientStateService.setStockRef(undefined);
      },
      logger
    );
  }

  public async next(dataValues?: { key: string; value: any }[]): Promise<any> {
    return super.next(dataValues);
  }

  public async generateRemoteAction(
    dataValues: { key: string; value: any }[]
  ): Promise<RemoteAction> {
    return super.generateRemoteAction(dataValues);
  }

  public generateComponent(
    viewContainerRef: ViewContainerRef
  ): ComponentRef<any> {
    const componentRef = super.generateComponent(viewContainerRef);

    if (componentRef.instance instanceof TimeCorrectionComponent) {
      this.logger.log(
        this.constructor.name,
        'Generate Component of Type TimeCorrectionComponent'
      );

      const appParams = this.appParameterService.appParameters$.getValue();
      if (appParams != undefined) {
        (<TimeCorrectionComponent>componentRef.instance).hideComment =
          appParams.getBooleanParameter(
            'imsmc.remoteaction-step.hidecomment.eot',
            false
          );
      }
    }

    return componentRef;
  }
}
